export default __webpack_public_path__ + "static/media/zaha.1e51452e.png";